// Typelizer digest 8a45cac26d3653e532c650e8b560117d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/payments/:payment_id/category_rule_draft */
  show: (
    params: { paymentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/payments/:payment_id/category_rule_draft', params, options),
    method: 'get',
  }),
}
